const baseFormStyling = {
    focusStyles: `focus:ring-0`,
    focusCheckbox: `focus:outline-none focus:ring-0 focus:ring-offset-0
      checked:focus:outline-none checked:focus:ring-0 checked:focus:shadow-none 
      checked:border-dark_green checked:bg-transparent checked:focus:bg-transparent 
      checked:focus:border-dark_green/70 checked:hover:bg-transparent 
      checked:hover:border-dark_green/70 checked:bg-center checked:bg-[size:auto]`,
    allFieldsStyles: `lg:px-9 lg:py-6 px-6 py-4 bg-transparent rounded-all_48 border-none text-p font-bold text-dark_green 
      placeholder:text-dark_green placeholder:text-[14px] lg:placeholder:text-[16px] placeholder:font-bold 
      option:text-dark_green option:text-p option:font-bold`,
    button: `flex items-center justify-center gap-4 border-gradient-button
      hover:form-fields-gradient-hover transition-all duration-500 ease-in-out`,
    errorActive: `[.error-active_&]:placeholder:text-error`,
    customShadow: `[box-shadow:0px_0px_50px_0px_rgba(0,_0,_0,_0.05),_0px_20px_50px_-20px_rgba(0,_0,_0,_0.10)]`,
  };
  

export const formStyling = {
  // Base styles
  label: `text-p font-400 text-black/70 mb-4`,
  field: `form-field`,
  fieldWrapper: `form-fields-gradient`,
  
  // Input elements
  input: `w-full
    disabled:bg-gray-100 disabled:cursor-not-allowed
    ${baseFormStyling.allFieldsStyles}
    ${baseFormStyling.focusStyles}
    ${baseFormStyling.errorActive}`,
    
  select: `w-full  
    appearance-none bg-white/30 border-none
    bg-auto bg-no-repeat bg-[position:95%_center]
    ${baseFormStyling.allFieldsStyles}
    ${baseFormStyling.focusStyles}
    ${baseFormStyling.errorActive}`,

  customSelect: `w-full z-10
  border-none rounded-all_48
  text-p font-bold text-dark_green
  placeholder:text-dark_green placeholder:text-[14px] lg:placeholder:text-[16px] placeholder:font-bold
  [&.dropdown-open]:shadow-none
  [&.dropdown-open]:z-50
  relative
  group`,
  customSelectDropdownParent: `w-full pt-12 pb-6 -mt-[30px] 
  absolute
  option:text-black/70 option:text-p
  ${baseFormStyling.customShadow}
  rounded-bottom_32
  transition-all duration-100 linear
  z-20
  bg-white`,
  customSelectDropdown: `w-full pt-0 pl-8
  relative h-full
  overflow-y-auto
  option:text-black/70 option:hover:text-dark_green option:text-p
  bg-white backdrop-blur-[20px]
  z-30
  rounded-bottom_32
  bg-white`,
  customSelectDropdownOption: `w-full py-3 hover:font-bold hover:text-dark_green focus:font-bold last:pb-0`,
  selectTrigger: `lg:px-9 lg:py-6 py-4 px-6 flex items-center justify-between [.error-active_&]:text-error`,
  selectFieldIcon: `transition-all duration-500 ease-in-out`,

  multiSelectDropdownOption: `text-black/70 [&_input]:hidden hover:font-bold hover:text-dark_green`,
  multiSelectDropdownOptionSelected: `text-dark_green font-bold`,

  procedureSelectOptionSelected: `text-dark_green`,
    
  checkbox: `h-4 w-4 cursor-pointer border-dark_green/70 rounded-[4px] relative
    text-black/70
    checked:after:absolute checked:after:content-[''] checked:after:block 
    checked:after:h-[8px] checked:after:w-[8px] checked:after:bg-orange
    checked:after:rounded-[2px] checked:after:-translate-y-1/2
    checked:after:top-1/2 checked:after:left-1/2 checked:after:-translate-x-1/2 
    ${baseFormStyling.focusCheckbox}`,
  
  facilitySearch: `w-full relative`,
  facilitySearchWrapper: `form-item form-item-facility-name relative z-30 bg-transparent`,
  facilitySearchLoading: `absolute text-dark_green right-6 top-4 spinner facility-spinner `,
  facilitySearchDropdownParent: `w-full pt-12 pb-5 -mt-[30px] absolute z-[21]
  transition-all duration-500 ease-in-out rounded-bottom_32
  bg-white
  ${baseFormStyling.customShadow}`,
  facilitySearchDropdown: `w-full pt-0 pl-8 pr-4 pb-6 relative
  bg-white custom-autocomplete max-h-60 backdrop-blur-[20px] overflow-y-auto rounded-bottom_32
  [&_li]:text-black/70 [&_li]:text-p`,
  facilitySearchDropdownItem: `w-full py-3 hover:text-dark_green hover:cursor-pointer`,
  facilitySearchDropdownItemBold: `font-bold`,
  facilitySearchDropdownSmallText: `block text-sm text-gray-600`,
  
  textbox: `resize-none w-full min-h-[120px]
    ${baseFormStyling.allFieldsStyles}
    ${baseFormStyling.focusStyles}`,
    
  // Button styles
    
  submitButton: `${baseFormStyling.allFieldsStyles} ${baseFormStyling.button}`,
  
  cancelButton: `${baseFormStyling.allFieldsStyles} ${baseFormStyling.button}`,
  
  simpleButton: `${baseFormStyling.allFieldsStyles} ${baseFormStyling.button}`,
  
  buttonIcon: `h-[12px] w-[12px]`,
  
  // Error state
  errorMessage: `text-error text-p_error pl-9 pt-2`
};